import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  buildSourceSearchUrl,
  isSourceSearch,
  toSourceSearchTableState,
} from "@/lib/search/sourceSearch";
import { Search } from "@/models/search/Search";
import { useGlobalSearchContext } from "@/providers/global-search/GlobalSearchContext";

/**
 * Reopens a stored search from recent searches, a favorite search card or the
 * search modal's list. A source search reruns on the Kilder page it was made
 * on; everything else reruns in the search modal (LAR-422).
 */
export const useOpenStoredSearch = (): ((search: Search) => void) => {
  const navigate = useNavigate();
  const { setSearchQuery, setInputValue, setIsSearchbarOpen } =
    useGlobalSearchContext();

  return useCallback(
    (search: Search) => {
      if (isSourceSearch(search)) {
        setIsSearchbarOpen(false);
        navigate(buildSourceSearchUrl(toSourceSearchTableState(search)));
        return;
      }

      setSearchQuery(search);
      setInputValue(search.searchTerm);
      setIsSearchbarOpen(true);
    },
    [navigate, setInputValue, setIsSearchbarOpen, setSearchQuery]
  );
};
